/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ElementSettingInfo,
  ElementSettingToAddInfo,
  ElementSettingToUpdateInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ElementSettingClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ElementSetting
   * @summary Получить настройки отображения по списку Id элементов дерева объектов
   * @request POST:/objecttree/ElementSetting/ElementSettingsByProjectElementIds
   * @secure
   */
  elementSettingGetElementSettingsByProjectElementIds = (
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ElementSettingInfo[], any>({
      path: `/objecttree/ElementSetting/ElementSettingsByProjectElementIds`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ElementSetting
   * @summary Получить настройки отображения по списку Id элементов дерева объектов и типу свойства
   * @request POST:/objecttree/ElementSetting/ElementSettingsByProjectElementIdsPropertyType
   * @secure
   */
  elementSettingGetElementSettingsByProjectElementIdsPropertyType = (
    query: {
      /**
       * Тип свойства
       * @format int32
       */
      propertyType: number
    },
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ElementSettingInfo[], any>({
      path: `/objecttree/ElementSetting/ElementSettingsByProjectElementIdsPropertyType`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ElementSetting
   * @summary Добавить новую настройку отображения
   * @request POST:/objecttree/ElementSetting
   * @secure
   */
  elementSettingAddElementSetting = (data: ElementSettingToAddInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/objecttree/ElementSetting`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ElementSetting
   * @summary Изменить существующую настройку отображения
   * @request PUT:/objecttree/ElementSetting
   * @secure
   */
  elementSettingUpdateElementSetting = (
    data: ElementSettingToUpdateInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, string>({
      path: `/objecttree/ElementSetting`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ElementSetting
   * @summary Удалить существующую настройку отображения
   * @request DELETE:/objecttree/ElementSetting
   * @secure
   */
  elementSettingDeleteElementSetting = (
    query: {
      /**
       * Идентификатор настройки отображения
       * @format uuid
       */
      elementSettingId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/ElementSetting`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
}
